import Template from "backbone/projects/templates/registration_actions.js.hamlc"

export default class RegistrationActionsView extends Backbone.View

  initialize: (options) ->
    @registrationStep = options.registrationStep
    @portfolioUrl = options.portfolioUrl
    @addSkillsUrl = options.addSkillsUrl
    @listenTo(@registrationStep, "change", @render)

  render: ->
    @$el.html(Template(
      registrationStep: @registrationStep
      portfolioUrl: @portfolioUrl
      addSkillsUrl: @addSkillsUrl
    ))



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/registration_actions_view.js.coffee